import { stories, type Story } from "@/mocks/stories";
import { formatCount } from "@/utils/format";
import StoryRow from "./StoryRow";
import { LikeButton } from "./StoryCard";
import { catStyles } from "./catStyle";

function LeadStory({ story }: { story: Story }) {
  return (
    <article className="flex h-full flex-col overflow-hidden rounded-3xl border border-primary-200 bg-background-50">
      <div className="flex items-center justify-between gap-3 bg-gradient-to-r from-primary-500 to-primary-400 px-6 py-4">
        <span className="inline-flex items-center gap-2 text-sm font-bold text-white">
          <span className="flex h-8 w-8 items-center justify-center rounded-full bg-white/20 text-lg">
            🛏️
          </span>
          本期·宿舍重头戏
        </span>
        <span className="font-heading text-4xl text-white/80">{story.reaction}</span>
      </div>
      <div className="flex flex-1 flex-col p-6">
        <h3 className="font-heading text-2xl leading-snug text-foreground-900">{story.title}</h3>
        <div className="mt-3 flex flex-wrap items-center gap-2 text-xs text-foreground-500">
          <span>
            <i className="ri-user-smile-line mr-1" />
            {story.author}
          </span>
          <span>
            <i className="ri-time-line mr-1" />
            {story.time}
          </span>
          <span>
            <i className="ri-eye-line mr-1" />
            {formatCount(story.views)}
          </span>
        </div>
        <div className="mt-4 space-y-3">
          {story.content.map((p, i) => (
            <p key={i} className="text-sm leading-relaxed text-foreground-700">
              {p}
            </p>
          ))}
        </div>
        <div className="mt-5 flex flex-wrap items-center gap-2 border-t border-dashed border-background-300 pt-4">
          {story.tags.map((t) => (
            <span key={t} className="rounded-md bg-primary-100 px-2 py-1 text-xs font-medium text-primary-800">
              #{t}
            </span>
          ))}
          <LikeButton count={story.likes} />
          <span className="flex items-center gap-1 rounded-full bg-background-100 px-3 py-1.5 text-sm text-foreground-500">
            <i className="ri-chat-3-line" /> {formatCount(story.comments)}
          </span>
        </div>
      </div>
    </article>
  );
}

export default function DormSection() {
  const dorm = stories.filter((s) => s.category === "dorm");
  const lead = dorm.find((s) => s.id === 11) ?? dorm[0];
  const rows = dorm.filter((s) => s.id !== lead.id).slice(0, 2);
  const st = catStyles.dorm;

  return (
    <section id="dorm" className="bg-background-100/70">
      <div className="mx-auto w-full max-w-7xl px-4 py-14 md:px-6 md:py-20">
        <div className="flex flex-col gap-3 md:flex-row md:items-end md:justify-between">
          <div>
            <span className={`inline-flex items-center gap-1.5 rounded-full px-3 py-1 text-xs font-bold ${st.badge}`}>
              🛏️ 宿舍生活搞笑爆料
            </span>
            <h2 className="mt-3 font-heading text-3xl text-foreground-900 md:text-4xl">
              熄灯之后，宿舍比电影还精彩
            </h2>
            <p className="mt-2 max-w-xl text-sm text-foreground-600 md:text-base">
              从深夜偷吃泡面到查寝「人体模特」，每一件都离谱得让人笑到拍大腿。
            </p>
          </div>
        </div>

        <div className="mt-7 grid grid-cols-1 gap-5 lg:grid-cols-5">
          <div className="lg:col-span-3">{lead && <LeadStory story={lead} />}</div>
          <div className="flex flex-col gap-5 lg:col-span-2">
            {rows.map((s) => (
              <StoryRow key={s.id} story={s} />
            ))}
            <a
              href="#submit"
              className="flex flex-1 flex-col items-center justify-center gap-2 rounded-2xl border border-dashed border-primary-300 bg-primary-50/60 p-5 text-center transition-colors hover:bg-primary-100/70"
            >
              <span className="text-3xl">🛏️</span>
              <span className="font-heading text-lg text-primary-800">你宿舍也有迷惑行为？</span>
              <span className="text-xs text-primary-700">爆料被选中，下期就是你宿舍的故事</span>
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}